module.exports = __webpack_public_path__ + "static/media/rev-leodah-gray.4a7992b7.jpg";